import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcCurrencySwitchClasses,
} from '@dxp-module/themes'

const currencySwitchStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcCurrencySwitchClasses
>(
  ({ palette, spacing, transitions }) => ({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: palette.common.white,
        '& + $track': {
          backgroundColor: palette.primaryDisabled.main,
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: palette.primary.light,
        border: `6px solid ${palette.common.white}`,
      },
    },
    switchContainer: {
      display: 'flex',
      justifyContent: 'center',
      margin: '5px 0 15px',
      '& p:first-child': {
        marginRight: 20,
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 13,
      border: `1px solid ${palette.grey[400]}`,
      backgroundColor: palette.primaryDisabled.main,
      opacity: 1,
      transition: transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
    selectCurrency: {
      color: palette.text.primary,
    },
    unselectedCurrency: {
      color: palette.text.primary,
    },
    selectedCurrency: {
      color: palette.primary.main,
    },
  }),
  { name: 'FC_CurrencySwitch' }
)

export default currencySwitchStyles
